import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseUrlChangeDialogComponent } from 'libs/shared-lib1/src/lib/base-url-change-dialog/base-url-change-dialog.component';
import { DialogService } from 'libs/shared-lib1/src/lib/shared/services/decativateDialog/dialog.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'nxt-test-translate',
  templateUrl: './test-translate.component.html',
  styleUrls: ['./test-translate.component.scss'],
})
export class TestTranslateComponent extends BaseUrlChangeDialogComponent implements OnInit {

  user!: { firstName: string; lastName: string; };
  welcome!: string;
  usernameLabel!: string;
  passwordLabel!: string;
  finishedLoadingTranslation = false;

  constructor(
    private translate: TranslateService,
    public override dialogService: DialogService
  ) {

    super(dialogService);

    translate.addLangs(['en', 'klingon']);

    translate.setDefaultLang('en');

    //To use english
    //translate.use('en');

    //To use spanish
    translate.use('es');

  }

  ngOnInit(): void {

    // hardcoded example
    this.user = { firstName: 'Sammy', lastName: 'Shark' };

    // synchronous. Also interpolate the 'firstName' parameter with a value.
    //https://github.com/ngx-translate/core/issues/85
    //this.welcome = this.translate.instant('welcomeMessage', { firstName: this.user.firstName });

    //asynchronous - gets translations then completes.
    this.translate.get(['login.username', 'login.password'])

      .subscribe(translations => {

        this.usernameLabel = translations['login.username'];
        this.passwordLabel = translations['login.password'];

        this.finishedLoadingTranslation = true;
      }
      );

  }

}
